/*
 * Module for the Insurance Carriers' Rates view
*/

rs.module("fund/configuration/insurancecarriers/rates",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, defaultAddValues, ratesGrid) {

            var form = $.js(jsSelectors.form);

            //
            // reload rate tiers in filter when insurance type filter is changed
            //
            form.js(jsSelectors.insuranceTypeFilterSelect).change(function () {
                var rateTierSelect = selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierFilterSelect)).loadOptionsFrom(
                    backendUrls.getRateTiers,
                    {
                        insuranceTypeKey: $(this).val()
                    },
                    {
                        withBlank: true,
                        blankValue: 0
                    }
                );

                rateTierSelect.setDisabled($(this).val() == 0);

                // Trigger the changed function for the rate tier filter
                onRateTierFilterChanged();
            });

            form.js(jsSelectors.insuranceRateTierFilterSelect).on("change", onRateTierFilterChanged);

            //
            // reload coverages in filter when insurance rate tier filter is changed
            //
            function onRateTierFilterChanged() {
                var selectedInsuranceTypeKey = form.js(jsSelectors.insuranceTypeFilterSelect).val() ?? 0;
                var selectedInsuranceRateTierKey = form.js(jsSelectors.insuranceRateTierFilterSelect).val() ?? 0;

                var coveragesSelect = selectHelper.getHelper(form.js(jsSelectors.coveragesFilterSelect)).loadOptionsFrom(
                    backendUrls.getCoverages,
                    {
                        insuranceTypeKey: selectedInsuranceTypeKey,
                        insuranceRateTierKey: selectedInsuranceRateTierKey
                    },
                    {
                        withBlank: true,
                        blankValue: 0
                    }
                );

                coveragesSelect.setDisabled(selectedInsuranceTypeKey == 0 || selectedInsuranceRateTierKey == 0);
            }

            //
            // reload rate tiers when insurance type is changed (this is for the form, above is for the filter)
            //
            form.js(jsSelectors.insuranceTypeSelect).change(function () {
                selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierSelect)).loadOptionsFrom(
                    backendUrls.getRateTiers,
                    {
                        insuranceTypeKey: $(this).val()
                    },
                    {
                        withBlank: true
                    }
                );

                // Trigger the changed function for the rate tier
                onRateTierChanged();
            });

            form.js(jsSelectors.insuranceRateTierSelect).on("change", onRateTierChanged);

            //
            // reload coverages when insurance rate tier is changed (this is for the form, above is for the filter)
            //
            function onRateTierChanged() {
                var selectedInsuranceTypeKey = form.js(jsSelectors.insuranceTypeSelect).val() ?? 0;
                var selectedInsuranceRateTierKey = form.js(jsSelectors.insuranceRateTierSelect).val() ?? 0;

                selectHelper.getHelper(form.js(jsSelectors.coveragesSelect)).loadOptionsFrom(
                    backendUrls.getCoverages,
                    {
                        insuranceTypeKey: selectedInsuranceTypeKey,
                        insuranceRateTierKey: selectedInsuranceRateTierKey
                    },
                    {
                        withBlank: true
                    }
                );
            }

            //
            // On rate row clicked, retrieve the rate record and display for edit
            //
            ratesGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    clearErrors();

                    $.get(backendUrls.getRateForEdit, { rateHistoryKey: values[0] }).done(function (result) {

                        form.js(jsSelectors.rateHistoryKeyHidden).val(result.rate.coverageRateHistoryKey);
                        form.js(jsSelectors.updateTokenHidden).val(result.rate.updateToken);

                        var insuranceTypeSelectHelper = selectHelper.getHelper(form.js(jsSelectors.insuranceTypeSelect));
                        insuranceTypeSelectHelper.setValue(result.insuranceTypeKey);
                        insuranceTypeSelectHelper.setDisabled(true);

                        var insuranceRateTierSelectHelper = selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierSelect));
                        insuranceRateTierSelectHelper.setValue(result.insuranceRateTierKey);
                        insuranceRateTierSelectHelper.setDisabled(true);

                        var coverageSelect = selectHelper.getHelper(form.js(jsSelectors.coveragesSelect)).replaceOptions(result.coverages);
                        coverageSelect.setValue(result.rate.insuranceCoverageKey);

                        form.js(jsSelectors.totalCostInput).val(result.formattedTotalCost);
                        form.js(jsSelectors.subsidyInput).val(result.formattedSubsidy);
                        form.js(jsSelectors.effectiveDate).val(result.rate.effectiveDate ? new Date(result.rate.effectiveDate).toISODateString() : null);
                        form.js(jsSelectors.terminationDate).val(result.rate.terminationDate ? new Date(result.rate.terminationDate).toISODateString() : null);

                        form.js(jsSelectors.repeatButton).hide();
                    });
                }

                _executeSelectionChanged = true;
            });

            //
            // On Add link click, reset necessary fields for adding a new rate
            //
            form.js(jsSelectors.addLink).click(function () {

                var selectedInsuranceTypeKey = defaultAddValues.insuranceTypeKey > 0 ? defaultAddValues.insuranceTypeKey : form.js(jsSelectors.insuranceTypeSelect).find("option:first-child").val();
                var selectedInsuranceRateTierKey = defaultAddValues.insuranceRateTierKey > 0 ? defaultAddValues.insuranceRateTierKey : form.js(jsSelectors.insuranceRateTierSelect).find("option:first-child").val();

                // once the default is selected, we need to reload the rate tiers select to get the right options for the insurance type
                selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierSelect)).loadOptionsFrom(
                    backendUrls.getRateTiers,
                    {
                        insuranceTypeKey: selectedInsuranceTypeKey
                    },
                    {
                        withBlank: true
                    }
                );

                // once the default is selected, we need to reload the coverages select to get the right options for the insurance type/rate tier
                selectHelper.getHelper(form.js(jsSelectors.coveragesSelect)).loadOptionsFrom(
                    backendUrls.getCoverages,
                    {
                        insuranceTypeKey: selectedInsuranceTypeKey,
                        insuranceRateTierKey : selectedInsuranceRateTierKey
                    },
                    {
                        withBlank: true
                    },
                    function () {

                        // after the new options have been loaded, default the coverage select - if the default key is zero, just select the first row
                        if (defaultAddValues.insuranceCoverageKey > 0) {
                            this.setValue(defaultAddValues.insuranceCoverageKey);
                        }
                        else {
                            this.selectIndex(0);
                        }

                        // these don't need to happen inside the callback function, but doing this allows everything to happen at once
                        // as opposed to these defaulting and then a split second later, the coverage drop down defaults
                        var insuranceTypeSelectHelper = selectHelper.getHelper(form.js(jsSelectors.insuranceTypeSelect));
                        var insuranceRateTierSelectHelper = selectHelper.getHelper(form.js(jsSelectors.insuranceRateTierSelect));

                        insuranceTypeSelectHelper.setValue(selectedInsuranceTypeKey);
                        insuranceTypeSelectHelper.setDisabled(false);
                        insuranceRateTierSelectHelper.setValue(selectedInsuranceRateTierKey);
                        insuranceRateTierSelectHelper.setDisabled(false);
                        form.js(jsSelectors.rateHistoryKeyHidden).val(-1);
                        form.js(jsSelectors.updateTokenHidden).val(null);
                        form.js(jsSelectors.totalCostInput).val("$0.00");
                        form.js(jsSelectors.subsidyInput).val("$0.00");
                        form.js(jsSelectors.effectiveDate).val(null);
                        form.js(jsSelectors.terminationDate).val(null);

                        form.js(jsSelectors.repeatButton).show();
                    }
                );

                ratesGrid.selectedValues = null;

                clearErrors();
            });

            //
            // Clear event banner and field errors
            //
            function clearErrors() {
                // clear event banner
                eventBanner.removeAllMessages();

                // clear field errors
                form.js(jsSelectors.insuranceTypeSelect).clearErrors();
                form.js(jsSelectors.insuranceRateTierSelect).clearErrors();
                form.js(jsSelectors.coveragesSelect).clearErrors();
                form.js(jsSelectors.totalCostInput).clearErrors();
                form.js(jsSelectors.subsidyInput).clearErrors();
                form.js(jsSelectors.effectiveDate).clearErrors();
                form.js(jsSelectors.terminationDate).clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);